// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/transponder-codes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/transponder-codes/emergency-code-confirmation.js';
import g1 from '../lessons/air-law/transponder-codes/transponder-codes.js';

mount([g0, g1]);
